import { useCallback } from 'react'
import { useAuth } from 'src/contexts/auth'
import { getMenuItemsForUser, hasPermission, UserType } from 'src/routes/routes.config'

export const usePermissions = () => {
  const { profile } = useAuth()
  const userType = profile as UserType

  const canAccessPath = useCallback((path: string) => hasPermission(userType, path), [userType])

  const hasRole = useCallback(
    (roles?: UserType[]) => {
      if (!roles || roles.length === 0) return true
      return roles.includes(userType)
    },
    [userType]
  )

  const getMenuItems = useCallback(() => {
    return getMenuItemsForUser(userType)
  }, [userType])

  const getUserType = useCallback(() => {
    return userType
  }, [userType])

  const isAdmin = useCallback(() => {
    return userType === UserType.ADMIN
  }, [userType])

  const isManager = useCallback(() => {
    return userType === UserType.MANAGER
  }, [userType])

  const isCowboy = useCallback(() => {
    return userType === UserType.COWBOY
  }, [userType])

  return {
    canAccessPath,
    hasRole,
    getMenuItems,
    getUserType,
    isAdmin,
    isManager,
    isCowboy
  }
}
